import { pb } from './pocketbase';

export const getStudentMemos = async (studentId) => {
    try {
        // Configuration simple sans options d'annulation
        const records = await pb.collection('student_memos').getList(1, 50, {
            filter: `student_id="${studentId}"`,
            sort: '-created',
            expand: 'created_by'
        });
        return records.items;
    } catch (error) {
        // Ne pas afficher d'erreur si c'est juste qu'il n'y a pas de mémos (404)
        if (error.status === 404) {
            return [];
        }
        console.error(`Erreur lors de la récupération des mémos de l'étudiant ${studentId}:`, error);
        throw error;
    }
};

export const createStudentMemo = async (memoData) => {
    try {
        if (pb.authStore.isValid && pb.authStore.model) {
            const memoWithPartnerId = {
                ...memoData,
                partner_id: pb.authStore.record.partner_id
            };
            const createdMemo = await pb.collection('student_memos').create(memoWithPartnerId);
            return createdMemo;
        } else {
            console.error('Aucun utilisateur authentifié. Impossible de créer le mémo sans partner_id.');
            return null;
        }            
    } catch (error) {
        console.error('Erreur lors de la création du mémo:', error);
        throw error;
    }
};

export const deleteStudentMemo = async (memoId) => {
    try {
        await pb.collection('student_memos').delete(memoId);
        return true;
    } catch (error) {
        console.error(`Erreur lors de la suppression du mémo ${memoId}:`, error);
        throw error;
    }
};